import { PageContext } from "ExtendiApp"
import React, { Fragment } from "react"
import Helmet from "react-helmet"

interface Props {
  pageContext: PageContext
}

export const Layout: React.FC<Props> = props => {
  const { children, pageContext } = props
  console.log("ALL PAGE PROPS :", props)
  console.log("pageContext :", pageContext)

  return (
    <Fragment>
      <Helmet>
        <link
          rel="stylesheet"
          href={
            "https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap"
          }
        />
      </Helmet>
      <main>{children}</main>
    </Fragment>
  )
}
